function closeOpenVueSelects(vm) {
  if (!vm) return;

  const tag = vm.$options && vm.$options._componentTag;
  const name = vm.$options && vm.$options.name;

  if ((tag === "v-select" || name === "v-select") && vm.open) {
    vm.open = false;
  }

  (vm.$children || []).forEach(closeOpenVueSelects);
}

export default {
  mounted() {
    this._plannerFilterScrollTargets = this.getPlannerFilterScrollTargets();
    this._plannerFilterScrollHandler = () => this.closePlannerFilterDropdowns();

    this._plannerFilterScrollTargets.forEach((target) => {
      target.addEventListener("scroll", this._plannerFilterScrollHandler, {
        passive: true,
      });
    });
  },
  beforeDestroy() {
    if (this._plannerFilterScrollHandler && this._plannerFilterScrollTargets) {
      this._plannerFilterScrollTargets.forEach((target) => {
        target.removeEventListener("scroll", this._plannerFilterScrollHandler);
      });
    }
  },
  methods: {
    getPlannerFilterScrollTargets() {
      const targets = new Set();

      [window, document, document.documentElement, document.body].forEach(
        (target) => {
          if (target) targets.add(target);
        }
      );

      [
        ".content-wrapper",
        ".app-content",
        ".table-scroll-container",
        ".table-wrapper",
        ".table-scrollbar-top",
      ].forEach((selector) => {
        document.querySelectorAll(selector).forEach((el) => targets.add(el));
      });

      if (this.$el) {
        let node = this.$el.parentElement;
        while (node && node !== document.body) {
          const style = window.getComputedStyle(node);
          const scrollable =
            /auto|scroll/.test(style.overflowY) ||
            /auto|scroll/.test(style.overflowX) ||
            /auto|scroll/.test(style.overflow);

          if (scrollable) {
            targets.add(node);
          }
          node = node.parentElement;
        }
      }

      return Array.from(targets);
    },
    closePlannerFilterDropdowns() {
      closeOpenVueSelects(this);
    },
  },
};
